import * as render from './render.pug'
import Layout from '../layout/index.js'
import { getNetworkInfo } from '../store/network-info/index.js'
import { setupWebsiteUrl, setupTagMamanger } from '~vueutil/index.js'
import { useMeta } from '~vueutil/meta.js'
import { useAuthStore } from '../store/auth/index.js'
export default {
  ...render,
  setup () {
    useAuthStore()
    const meta = useMeta()
    const { ogUrl, ogTitle, ogDescription, ogImage } = meta

    const { websiteUrl, tagManagerId } = getNetworkInfo()
    setupWebsiteUrl(websiteUrl)
    if (tagManagerId) {
      setupTagMamanger(tagManagerId)
    }

    return {
      ogUrl, ogTitle, ogDescription, ogImage
    }
  },
  components: {
    Layout
  }
}
